import React from 'react';
import Services from './services';
export default function ServicesHome() {
  return <Services />;
}
